

































import { Component, Vue } from "vue-property-decorator";
import ForgotPassword from "@/views/pages/forgotPassword.vue";
@Component({
  name: "ResetPasswordExpired",
  components: {
    ForgotPassword,
  },
})
export default class ResetPasswordExpired extends Vue {
  public forgotPassword() {
    (this.$refs.forgotPassword as ForgotPassword).show();
  }
}
